<template>
  <div class="content-page">
    <div class="course-box">
      <div class="course-title">
        支付宝创建小程序
      </div>
      <div class="course-blak-30"></div>
      <div class="course-p">
        1、使用支付宝扫码可以唤起开发者中心：
      </div>
      <img
        class="course-img"
        src="../assets/img/appltCourse/appltAliRGuide-1.png"
        alt
      />
      <img
        class="course-img"
        src="../assets/img/appltCourse/appltAliRGuide-2.png"
        alt
      />
      <div class="course-p">2、进入《我的》，点击创建小程序</div>
      <img
        class="course-img"
        src="../assets/img/appltCourse/appltAliRGuide-3.png"
        alt
      />
      <div class="course-p">
        3、新建小程序，请《填写完整信息》，<span class="text-danger"
          >以免信息不完整导致小程序上架无法提交的问题。</span
        >
      </div>
      <img
        class="course-img"
        src="../assets/img/appltCourse/appltAliRGuide-4.png"
        alt
      />
      <div class="course-p">
        4、完成小程序创建，请进行后续
        <el-link :underline="false" type="primary" @click="linkTo('/applt')"
          >授权动作</el-link
        >。
      </div>
    </div>
  </div>
</template>

<script>
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [commonFuc],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style>
/* 2020-3-31 */
.course-box {
  /* padding: 30px 600px 30px 100px; */
  padding: 30px;
}

.course-title {
  color: #666;
  font-size: 30px;
}

.course-text {
  color: #666;
  font-size: 22px;
  color: rgb(255, 101, 0);
  line-height: 36px;
}

.course-orange {
  color: rgb(255, 101, 0);
  font-style: inherit;
}

.course-p {
  color: #666;
  font-size: 14px;
  line-height: 32px;
}

.course-img {
  display: block;
  max-width: 1000px;
}

.course-blak-30 {
  height: 30px;
}

.course-blak-20 {
  height: 20px;
}

/* 2020-3-31end */
</style>
